<script setup lang="ts">
import { RouterLink } from 'vue-router';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { PROFILE_NAV_ITEMS } from '@/js/account/components/profile/profile-nav-items';
import { classNames } from '@/js/lib/bem';

const cn = classNames('profile-bottom-nav');
</script>

<template>
  <nav :class="cn()" aria-label="Account navigation">
    <ul :class="cn('items')">
      <li
        v-for="item in PROFILE_NAV_ITEMS"
        :key="item.routeName"
        :class="cn('item')"
      >
        <RouterLink
          :to="{ name: item.routeName }"
          :class="cn('item-link')"
          :active-class="cn('item-link', { active: true })"
        >
          <BaseIcon
            :name="item.icon"
            :class="cn('item-icon')"
            :width="24"
            :height="24"
          />
          <span :class="cn('item-text')">{{ item.label }}</span>
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss" scoped>
.profile-bottom-nav {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  padding-bottom: env(safe-area-inset-bottom, 0);
  background-color: var(--color-white);
  box-shadow: var(--shadow);
  font-family: var(--font-family-sans);

  &__items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 16px 22px;
    list-style: none;
    height: 100%;
  }

  &__item {
    min-width: 0;
    width: 100%;
  }

  &__item-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    text-decoration: none;
    color: var(--color-accent);
    transition: color 0.2s ease-in-out;

    &_active {
      color: var(--color-primary);
    }
  }

  &__item-text {
    font-size: 10px;
    line-height: 1.2;
    font-weight: var(--font-weight-regular);
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
}
</style>
